import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import parse from "html-react-parser";
import "./index.css";

const PlayButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 69 69" fill="none">
    <circle cx="34.2143" cy="34.2143" r="34.2143" fill="#FF541C"/>
    <path d="M47.5454 31.616C49.5454 32.7707 49.5454 35.6574 47.5454 36.8121L29.8006 47.0571C27.8006 48.2118 25.3006 46.7684 25.3006 44.459L25.3006 23.9691C25.3006 21.6597 27.8006 20.2163 29.8006 21.371L47.5454 31.616Z" fill="white"/>
  </svg>
);

const getVideoId = (url) => {
  if (!url) return "";
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|live\/|shorts\/))([-\w]+)/);
  return match ? match[1] : "";
};

const ArbitrageSection = ({ data }) => {
  const [playing, setPlaying] = useState(false);
  const imgPath = process.env.REACT_APP_IMAGES;

  if (!data) return null;

  const videoId = getVideoId(data.videoUrl);

  return (
    <section className="arbitrage-section section-spacing">
      {/* <span className="video-glow-blob-1" style={{top:'7%',left:'30%'}} />
      <span className="video-glow-blob-2" style={{top:'7%',left:'40%'}} />
      <span className="video-glow-blob-1" style={{top:'7%',left:'50%',background:'#FF541C'}} />
      <span className="video-glow-blob-2" style={{top:'7%',right:'30%',background:'#F31454'}} /> */}
      <Container className="arbitrage-card-container">
        <div className="arbitrage-card">
          <Row className="align-items-center">
            <Col lg={6} className="arbitrage-video-col">
              <div className="arbitrage-video-wrapper">
                <div className="arbitrage-thumb-click" onClick={() => !playing && setPlaying(true)} role="button" tabIndex={0} aria-label="Play video">
                    <img
                      src={`${imgPath}${data.thumbnail}`}
                      alt={data.badge}
                      className="arbitrage-thumbnail"
                      loading="lazy"
                    />
                    {!playing && (
                      <span className="arbitrage-play-btn">
                        <PlayButton />
                      </span>
                    )}
                    {playing && (
                      <>
                        <div className="video-loading-spinner" />
                        <iframe
                          className="arbitrage-iframe video-iframe-overlay"
                          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                          title={data.badge}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          frameBorder="0"
                        />
                        <button className="arbitrage-close-btn" onClick={(e) => { e.stopPropagation(); setPlaying(false); }} aria-label="Close video">✕</button>
                      </>
                    )}
                  </div>
              </div>
            </Col>
            <Col lg={6} className="arbitrage-text-col">
              <div className="arbitrage-badge-row">
                <span className="arbitrage-badge-square" />
                <span className="arbitrage-badge">{parse(data.badge)}</span>
              </div>
              <h2 className="arbitrage-heading">{parse(data.heading)}</h2>
            </Col>
          </Row>

          {data.stats && (
            <div className="arbitrage-stats-row">
              {data.stats.map((stat, i) => (
                <div key={i} className="arbitrage-stat">
                  <p className="arbitrage-stat-value">{parse(stat.value)}</p>
                  <p className="arbitrage-stat-label">{parse(stat.label)}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </Container>
    </section>
  );
};

export default ArbitrageSection;
